import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    auth: false,
    performSignup: false,
    loggedIn: false,
    otpId: null,
    REFRESH_INTERVAL_AUTH_TOKEN: 3000000
  }),

  actions: {
    setAuth(flag) {
      this.auth = flag;
    },
    setPerformSignup(flag) {
      this.performSignup = flag;
    },
    setOtpId(payload) {
      this.otpId = payload;
    }
  },

  getters: {
    isAuthenticated: (state) => state.auth
  }
});
